import {
  BookOpen,
  Briefcase,
  Car,
  CircleHelp,
  ClipboardList,
  Compass,
  Flower2,
  GitBranch,
  GraduationCap,
  HandHeart,
  Headphones,
  Heart,
  House,
  Leaf,
  Moon,
  NotebookPen,
  Package,
  Pill,
  Sprout,
  TrendingUp,
  Users,
  Utensils,
  Wallet,
  Waves,
  Wind,
} from 'lucide-react'

/**
 * Lucide kebab-case name → component.
 *
 * Mirrors the allowlist in data-service src/presentation/icons.js (served
 * by GET /api/presentation/icons), which in turn mirrors what AstaApp
 * bundles in components/ui/Icon.tsx. Importing the icons by name keeps
 * the admin bundle to this set instead of the full lucide library; a
 * server-allowlisted name that is missing here still renders as a
 * labelled placeholder (see PathwayIcon) until it is added.
 */
export const LUCIDE_ICONS = {
  // Bundled in AstaApp today
  compass: Compass,
  car: Car,
  wallet: Wallet,
  briefcase: Briefcase,
  package: Package,
  utensils: Utensils,
  moon: Moon,
  sprout: Sprout,
  wind: Wind,
  headphones: Headphones,
  waves: Waves,
  'book-open': BookOpen,
  'notebook-pen': NotebookPen,
  'git-branch': GitBranch,
  leaf: Leaf,
  heart: Heart,
  'trending-up': TrendingUp,
  'circle-help': CircleHelp,
  // Added with the resource-category release
  house: House,
  users: Users,
  'hand-heart': HandHeart,
  'clipboard-list': ClipboardList,
  'graduation-cap': GraduationCap,
  pill: Pill,
  'flower-2': Flower2,
}

/** Last-resort icon, matching data-service FALLBACK_ICON. */
export const FALLBACK_ICON = 'compass'

export function getLucideIcon(name) {
  return name ? LUCIDE_ICONS[name] || null : null
}
